// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.photo-text-section[data-v-6e87133e]{margin-left:auto;margin-right:auto;max-width:91rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
